import React from 'react';
import { Button } from 'reactstrap';

const EmptyGiftlist = (props) => {

    const boxStyle = {
        width: "100%",
        height: "200px",
        border: "4px dashed #CCC",
        display: "flex",
        marginBottom: "8px"
    }
    
    return (
        <div className="text-center" style={boxStyle}>
            <div style={{margin: "auto"}}>
                <h5>No items have been added yet.</h5>
                <Button className="btn-success mt-3" onClick={() => props.handler()}>
                    <i className="flaticon2-plus-1"></i> ADD ITEMS</Button>
            </div>
        </div>);
}
export default EmptyGiftlist;